import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store';
import VueSweetalert2 from 'vue-sweetalert2'
import Toasted from 'vue-toasted'
import Notifications from 'vue-notification'
import VueFeather from 'vue-feather'
import VueApexCharts from 'vue-apexcharts'
import FunctionalCalendar from 'vue-functional-calendar'

import PxCard  from './components/Pxcard.vue'
Vue.component(PxCard.name, PxCard)

// Import Theme scss
import './assets/scss/app.scss'

// Socket
import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://trade.ericson.my',
  vuex: {
    store,
    actionPrefix: 'WS_',
    mutationPrefix: 'WS_'
  },
  options: { path: "/socket.io" }
}))

// Moment
import momentx from 'moment'
import moment from 'vue-moment'
Vue.use(moment)

// HTTP Plugin
import axios from 'axios'
Vue.prototype.$http = axios
if (localStorage.getItem('accessToken')) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
}
Vue.prototype.$http.interceptors.response.use((response) => { return response },(error) => {
  if (error.response.status === 401 && parseInt(localStorage.getItem('exp')) < momentx().format('x')) {
    window.location.href = '/login'
    return
  }
  return Promise.reject(error)
})

// Highchart
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'

// Google Analytic
import {version} from '../package'
import VueAnalytics from 'vue-ua'
Vue.use(VueAnalytics, {
  appName: 'Trade Web',
  appVersion: version,
  trackingId: 'UA-210561280-1',
  // vueRouter: router,

  // Global Dimensions and Metrics can optionally be specified.
  // globalDimensions: [
  //   { dimension: 1, value: 'FirstDimension' },
  //   { dimension: 2, value: 'SecondDimension' }
  // ],

  // globalMetrics: [
  //   { metric: 1, value: 'MyMetricValue' },
  //   { metric: 2, value: 'AnotherMetricValue' }
  // ]
})

Vue.use(Notifications)
Vue.use(VueSweetalert2)
Vue.use(VueFeather)
Vue.use(BootstrapVue)
Vue.use(HighchartsVue)
stockInit(Highcharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
})
Vue.use(Toasted,{
  iconPack: 'fontawesome'
})
Vue.component('Breadcrumbs', Breadcrumbs)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')